import uiReducer from "./uiReducer";
import userReducer from "./userReducer";
import { combineReducers } from "redux";

const appReducer = combineReducers({
  ui: uiReducer,
  userState: userReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "CLEAR_SESSION") {
    const resetState = appReducer(undefined, action);

    return {
      ...resetState,
      ui: {
        ...resetState.ui,
        theme: state?.ui?.theme || resetState.ui.theme,
      },
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
